import * as React from 'react';

interface WhatsAroundHeaderProps {
  className: string;
  title: string;
}

export const WhatsAroundHeader: React.FunctionComponent<WhatsAroundHeaderProps> = ({ className, title }) => (
  <div className={`uitk-cell all-cell-1-1 ${className}`}>
    <h3 className="uitk-type-heading-600 uitk-type-bold">{title}</h3>
  </div>
);

WhatsAroundHeader.displayName = 'WhatsAroundHeader';
